import {
  parsePhoneNumberFromString,
  validatePhoneNumberLength,
} from "libphonenumber-js/max";

const candidate = (phone) => ({
  e164: phone.number,
  country: phone.country ?? null,
});
const ok = (phone, via) => ({ status: "ok", ...candidate(phone), via });

export function parsePhone(raw, country) {
  const text = String(raw ?? "").trim();
  if (!text) return { status: "empty" };

  const prefixed = text.startsWith("+") || text.startsWith("00");
  const digits = (prefixed ? text.replace(/^00/, "") : text).replace(/\D/g, "");
  const readings = [];
  const read = (value, defaultCountry) => {
    readings.push(validatePhoneNumberLength(value, defaultCountry));
    return parsePhoneNumberFromString(value, defaultCountry);
  };
  const international = read(`+${digits}`);
  if (prefixed) {
    if (international?.isValid())
      return ok(international, "international_prefix");
  } else {
    const region = String(country ?? "").toUpperCase();
    const local = region.trim() ? read(digits, region) : undefined;
    if (local?.isValid()) {
      if (international?.isValid() && local.number !== international.number) {
        return {
          status: "ambiguous",
          candidates: [candidate(local), candidate(international)],
        };
      }
      return ok(local, "local");
    }
    if (international?.isValid())
      return ok(international, "international_no_plus");
  }
  const reason = !digits
    ? "not_a_number"
    : digits.length > 15
      ? "too_long"
      : readings.includes("TOO_SHORT")
        ? "too_short"
        : "not_a_number";
  return { status: "invalid", reason };
}
